<template>

  <YazamData class="yazam" v-if="showYazamData && selectedEnt?.info" :yazam_data="selectedEnt?.info" />
  <div id="offers_details" v-if="item">
    <div class="centered">
        <Breadcrumbs :items="breadcrumbsComp" class="breadcrumbs" />
        <div class="head">
            <!-- <h1 v-text="'פירוט ההצעות במכרז' + ' > ' + item.name + (compeareStats? ' > השוואה סופית ': '')"></h1> -->
            <h1 >פירוט ההצעות במכרז</h1>
            <router-link :to="{ name: 'projects_manager'}" class="btn_b text_s">חזרה לרשימת המכרזים</router-link>
        </div>
        <ul class="steps">
            <div class="arrow_container" v-show="stepIndex > 0" @click="stepIndex--">
                <div class="arrow_right_icon icon"></div>
            </div>
            <li class="step" v-for="(step, index) in steps" :class="{active: stepIndex === index}" :key="index">
                <span class="num" v-text="index + 1" v-if="stepIndex <= index"></span>
                <div class="icon_container" v-else>
                    <span class="icon check_white_icon"></span>
                </div>
                <span class="name" v-text="step.name"></span>
            </li>
        </ul>
        <div class="prj_data_compare_con">
            <div class="prj_data">
                <div class="icon_text_con">
                    <div class="icon_con">
                        <div class="icon building_white_icon"></div>
                    </div>
                    <div class="text">
                        <p class="name" v-text="item.name"></p>
                        <span v-if="+item.is_open" >הגישו מועמדות<span class="mobile-none">למכרז זה </span>
                              {{ entrepreneurs.length }} יזמים</span>
                        <span v-else><span class="mobile-none">למכרז זה </span>
                             הוזמנו {{ item?.invitations }} יזמים, מתוכם הגישו מועמדות {{ entrepreneurs.length }} יזמים</span>
                    </div>
                </div>
                <!-- <div class="actions">
                    <div class="csv" @click="dwonloadCsv"></div>
                </div> -->
            </div>
            <div class="compare_btn_con line_seperators">
                <!-- <p>בחרת <strong>{{ selectedEntrepreneursIds.length }}</strong> יזמים לשלב ב</p> -->
                <div class="csv" @click="dwonloadCsv">
                    <div class="icon"></div>
                    <span>הורד כקובץ למחשב</span>
                </div>
                <div class="btn" @click="compeareStats=!compeareStats" v-text="compeareStats ? 'חזרה לכלל ההצעות' : 'הצג השוואה סופית'"></div>
            </div>
        </div>
        <div class="select_res_ent_con">
            <ComparisonTable 
                v-if="compeareStats"
                :selectedEnts="selectedEnts"
                :showTrans="showTrans"
            />
            <SelectEnt 
                v-else-if="stepIndex === 0"
                :entrepreneurs="entrepreneurs"
                :selectedEntrepreneursIds="selectedEntrepreneursIds"
                @select-entrepreneur="handleSelectEnt"
                @rate-part="ratePart"
                @addNotePopup="handleAddNotePopup"
            />
            <ClauseComparison 
                v-else-if="stepIndex === 1 && contract"
                ref="clauseComparison"
                :selectedEnts="selectedEnts"
                :contract="contract"
                mode="edit"
            />
            <div v-else-if="stepIndex === 2">
                <SelectEnt 
                    :entrepreneurs="entrepreneurs"
                    :selectedEntrepreneursIds="selectedEntrepreneursIds"
                    @select-entrepreneur="handleSelectEnt"
                    @rate-part="ratePart"
                    @addNotePopup="handleAddNotePopup"
                    :isFinalSelection="true"
                />
            </div>
            
        </div>
    </div>
    <div class="sticky_bottom_bar" v-if="!compeareStats">
        <div class="centered">
            <div class="selected-count">
                <span>נבחרו {{ selectedEntrepreneursIds.length }} יזמים</span>
            </div>
            <div class="stats">
                <div class="notes-stats">
                  <div class="note-stat" v-if="notesCountByType.settings">
                    <span class="label">מסחרי:</span>
                    <span class="count">{{ notesCountByType.settings }}</span>
                    <span class="text">הערות</span>
                  </div>
                  <div class="note-stat" v-if="notesCountByType.tech">
                    <span class="label">טכני:</span>
                    <span class="count">{{ notesCountByType.tech }}</span>
                    <span class="text">הערות</span>
                  </div>
                  <div class="note-stat" v-if="notesCountByType.legal">
                    <span class="label">משפטי:</span>
                    <span class="count">{{ notesCountByType.legal }}</span>
                    <span class="text">הערות</span>
                  </div>
                </div>
            </div>
            <div class="actions">
                <button v-if="stepIndex > 0" class="btn_b outline" @click="stepIndex--">
                    חזרה
                </button>
                <button class="btn_b outline next" @click="moveNextStep" :disabled="selectedEntrepreneursIds.length === 0" 
                    v-text="stepIndex === 0 ? 'המשך לשלב הבא' : 
                           stepIndex === 1 ? 'שלח בקשה לשיפור הצעות' : 
                           'סיים סינון נוסף'">
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import YazamData from '@/components/YazamData.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import SelectEnt from '@/components/offersDetails/SelectEnt.vue';
import ClauseComparison from '@/components/offersDetails/ClauseComparison.vue';
import ComparisonTable from '@/components/offersDetails/ComparisonTable.vue';
export default {
    components: { YazamData, Breadcrumbs, SelectEnt, ClauseComparison, ComparisonTable },
    data() {
        return {
            item: {},
            entrepreneurs: [],
            contract: null,
            selectedEntrepreneursIds: [],
            token: this.$route.params?.token,
            filterSortBy: 'hight_to_low',
            // show_contract_not_aprouve: true,
            selectedEntrepreneurId: null,
            compeareStats: false,
            showTrans:false,
            options: [
                { key: 'hight_to_low', val: "ציון מהגבוה לנמוך"},
                { key: 'low_to_hight', val: "ציון מהנמוך לגבוה"}
            ],
            entr_data: {},
            showYazamData: false,
            partType: 'settings',
            selectedClause: null,
            stepIndex: 0,
            steps: [
                { name: 'סבב א׳: סינון ראשוני'},
                { name: 'סבב ב׳: שיפור הצעות במכרז'},
                { name: 'סבב ב׳: סינון נוסף'}
            ]
        }
    },
    mounted() {
        this.$bus.$emit('show-loader');
        this.api({ action: 'projects/get', data: { token: this.token}}, (data) => {
            this.item = data.data;
        })
        this.api({ action: 'projects/get_applying_project_users', data: { token: this.token}}, (data) => {
        console.log(data, "data")
            this.contract = data.data.contract;
            this.contract.types[0].parts[0].isOpen = true;
            this.entrepreneurs = data.data.users;
            if (this.entrepreneurs.length >  0)
            {
                this.entrepreneurs.map((ent) => {
                    let sum = 0;
                    for (let typeIndex = 0; typeIndex < ent.contract.types.length; typeIndex++) {
                      const type = ent.contract.types[typeIndex];
                      for (let partIndex = 0; partIndex < type.parts.length; partIndex++) {
                        const part = type.parts[partIndex];
                        for (let clauseIndex = 0; clauseIndex < part.clauses.length; clauseIndex++) {
                          const clause = part.clauses[clauseIndex];
                          
                          if (clause.approve === false) {
                            sum = sum + 1;
                          }
                        }
                      }
                    }
                    ent.contract.notAprouveClauseNum = sum
                    ent.show_contract_not_aprouve = false;
                    this.selectedEntrepreneursIds.push(ent.id)
                    return ent
                })
                this.selectedEntrepreneurId = this.entrepreneurs[0].id;
            }
            // temp
            // this.moveNextStep();
            this.$bus.$emit('hide-loader');
        })
        this.$bus.$on('open_yazamdata', () => { this.showYazamData = true });
        this.$bus.$on('close_yazamdata', () => { this.showYazamData = false });
    },
    methods: {
        rewardClauses(user) {
            const processPartClauses = (part, acc) => {
                // Process clauses in current part
                if (part.clauses && part.clauses.length > 0) { 
                    part.clauses.forEach(element => {
                        acc.push(element);
                    });
                }
                
                // Recursively process nested parts
                if (part.parts && part.parts.length > 0) {
                    part.parts.forEach(subPart => {
                        processPartClauses(subPart, acc);
                    });
                }
                
                return acc;
            };

            const res = [];
            
            // Process each type's parts
            if (user.contract && user.contract.types) {
                user.contract.types.forEach(type => {
                    if (type.parts && type.parts.length > 0) {
                        type.parts.forEach(part => {
                            processPartClauses(part, res);
                        });
                    }
                });
            }
            
            return res;
        },
        getClauseForUser(user, clauseId) {
            const allClauses = this.rewardClauses(user);
            
            return allClauses.find(clause => clause.clause_id === clauseId);
        },
        ratePart(part) {
            this.api({ action: 'projects/rate_part', data: { token: this.token, part_bid_id: part.part_bid_id, rate: part.rate }}, (data) => {
                if (data.data) {
                    this.toast('הציון נשמר בהצלחה', 'success');
                } else {
                    this.toast('שגיאה בשמירת הציון', 'error');
                }
            })
        },
        // addNewNote() {
        //     this.api({ action: 'projects/add_note', data: { token: this.token, clause_note_id: this.selectedClause?.id, lawyer_note: this.selectedClause.lawyer_note }}, (data) => {
        //         if (data.data) {
        //             this.toast('הערה נוספה בהצלחה', 'success');
        //             this.entrepreneurs = this.entrepreneurs.map(ent => {
        //                 const updatedEnt = { ...ent };
        //                 if (updatedEnt.reward_clauses) {
        //                     updatedEnt.reward_clauses = updatedEnt.reward_clauses.map(clause => {
        //                         if (clause.id === this.selectedClause.id) {
        //                             return {
        //                                 ...clause,
        //                                 lawyer_note: this.selectedClause.lawyer_note
        //                             };
        //                         }
        //                         return clause;
        //                     });
        //                 }
        //                 return updatedEnt;
        //             });
        //             // this.selectedClause.lawyer_note = this.lawyer_note;
        //         } else {
        //             this.toast('שגיאה בשמירת הערה', 'error');
        //         }

        //         this.selectedClause = null;
        //     })
        // },
        async dwonloadCsv() {
            try {
                // Make the fetch request
                const response = await fetch(window.api_url + 'projects/get_compeare_csv', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem('user_token')
                    },
                    body: JSON.stringify({ token: this.token }),
                });

                // Check if the response is ok
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // Get the blob from the response
                const blob = await response.blob();

                // Create a URL for the blob
                const url = window.URL.createObjectURL(blob);

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.download = 'data.csv'; // Same filename as set in PHP

                // Append link to body, click it, and remove it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Clean up the URL object
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Error downloading CSV:', error);
                // Handle error appropriately (e.g., show user feedback)
            }

        },
        handleSelectEnt(id) {
            const delInted = this.selectedEntrepreneursIds.indexOf(id)
            if (delInted > -1) {
                this.selectedEntrepreneursIds.splice(delInted, 1)
            } else {
                this.selectedEntrepreneursIds.push(id)
            }
        },
        findClauseById(id, parts) {
            for (const part of parts) {
                for (const clause of part.clauses) {
                    if (clause.id === id) {
                        return clause;
                    }
                }
            }
            return null;
        },
        async moveNextStep() {
            if (this.stepIndex === 1) {
                // this.alert("בקשה לשיפור הצעות נשלח ליזמים");
                const { data: is_success } = await this.api({ action: 'projects/send_improve_offers', data: { token: this.token, ents_ids: this.selectedEntrepreneursIds }});
                if (is_success) {
                    this.$refs.clauseComparison.sentImprovesPopup = true;
                } else {
                    this.alert("שגיאה בשליחת בקשה לשיפור הצעות");
                }

                // this.stepIndex++;
            } else if (this.stepIndex === 2) {
                this.alert("סינון נוסף הושלם בהצלחה");
            } else {
                this.stepIndex++;
            }
        }
    },
    computed: {
        
        breadcrumbsComp() {
            const res =[
                { label: 'רשימת מכרזים', path: '/projects_manager' },
                { label: 'פירוט ההצעות במכרז', path: '/offers_details/'+ this.token, func: () => { this.compeareStats = false } }
            ]
            if (this.compeareStats) {
                res.push({ label: 'השוואה סופית', path: '/offers_details/'+ this.token })
            }
            return res;
        },
        selectedEnt() {
            const selectedItem = this.entrepreneurs.filter(item => item.id === this.selectedEntrepreneurId)
            if (selectedItem.length > 0) {
                // for (let i = 0; i < selectedItem[0].contract.parts.length; i++) {
                //         const part = selectedItem[0].contract.parts[i];
                //         for (let i = 0; i < part.clauses.length; i++) {
                //             const clause = part.clauses[i];
                //             if (clause.clause_id == "24919" && clause.user_id == "140") console.log(clause, "selec ent", part.id);
                            
                //             if (clause.approve === false) {
                //                 // sum = sum + 1
                //             }
                //         }
                //     }
                return selectedItem[0]
            }
            return null;
        },
        selectedEnts() {
            const selectedItem = this.entrepreneurs.filter(item => this.selectedEntrepreneursIds.includes(item.id))
            if (selectedItem.length > 0) {
                return selectedItem
            }
            return null;
        },
        entrepreneursComp() {
            const sortedEntrepreneurs = this.entrepreneurs.slice();

            if (this.filterSortBy === 'hight_to_low') {
                return sortedEntrepreneurs.sort((a, b) => b.main_grade - a.main_grade);
            }
            if (this.filterSortBy === 'low_to_hight') {
                return sortedEntrepreneurs.sort((a, b) => a.main_grade - b.main_grade);
            }
            // Return a copy of the original array if no sort option is selected
            return sortedEntrepreneurs;
        },
        notesCountByType() {
            const counts = {
                settings: 0,
                tech: 0,
                legal: 0
            };
            
            if (!this.contract || !this.contract.types) {
                return counts;
            }
            
            // Function to count notes in a part and its sub-parts
            const countNotesInPart = (part) => {
                // Count notes in current part's clauses
                if (part.clauses) {
                    part.clauses.forEach(clause => {
                        if (clause.notes && Array.isArray(clause.notes)) {
                            counts[part.type] += clause.notes.length;
                        }
                    });
                }
                
                // Recursively count notes in sub-parts
                if (part.parts && part.parts.length > 0) {
                    part.parts.forEach(subPart => {
                        countNotesInPart(subPart);
                    });
                }
            };
            
            // Process all types and their parts
            this.contract.types.forEach(type => {
                if (type.parts && type.parts.length > 0) {
                    type.parts.forEach(part => {
                        countNotesInPart(part);
                    });
                }
            });
            
            return counts;
        }
    },
    watch: {
        stepIndex() {
            if (this.stepIndex === 1) {
                this.showTrans = false
                setTimeout(() => {
                    this.showTrans = true
                }, 100)
            }
        },
        compeareStats(newVal) {
            if (newVal) {
                this.showTrans = false
                setTimeout(() => {
                    this.showTrans = true
                }, 100)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#add_note_popup {
    .inner {
        h3 { text-align: center;}
        textarea { width: 100%; height: 100px; }
    }
}
#offers_details { background: var(--pageBG); padding-bottom: 100px;
    @include mobile {
        padding-bottom: 70px;
    }
    .grade_con { display: flex; align-items: center; justify-content: center; border-radius: 50%; border: 1px solid var(--btn_color); min-width: 48px; height: 48px;
        span { font-size: var(--h5); color: transparent;}
    }
    .btn_b { width: fit-content;}
    &>.centered { display: flex; flex-direction: column; gap: var(--gap_mid);
        @include mobile {
            gap: 10px;
            padding: 0 8px;
        }
        .head { display: flex; justify-content: space-between;
            @include mobile {
                flex-direction: column;
                gap: 8px;
                align-items: flex-start;
            }
            h1 { color: var(--btn_color); font-size: var(--h2);
                @include mobile {
                    font-size: 22px;
                }
            }
        }
        .prj_data_compare_con { display: flex; gap: var(--gap_mid);
            @include mobile {
                flex-direction: column;
                gap: 8px;
            }
            &>div { display: flex; align-items: center; gap:  var(--gap_mid); background: #fff; border-radius: var(--radius_md);  padding: var(--gap_mid);
                @include mobile {
                    flex-direction: column;
                    gap: 8px;
                    padding: 10px;
                }
            }
            .compare_btn_con {
                justify-content: space-between;
                @include mobile {
                    flex-direction: column;
                    gap: 8px;
                }
            }
            .line_seperators {
                display: flex;
                align-items: center;
                @include mobile {
                    flex-direction: column;
                    gap: 8px;
                    & > *:not(:last-child) {
                        padding-left: 0;
                        padding-bottom: 8px;
                        &::after {
                            display: none;
                        }
                    }
                }
                & > *:not(:last-child) {
                    position: relative;
                    // margin-left: var(--gap_mid);
                    padding-left: var(--gap_mid);
                    &::after {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        height: 100%;
                        width: 1px;
                        background-color:  #CCDAE2;
                    }
                }
            }
            .prj_data { flex: 1; justify-content: space-between;
                
                .icon_text_con { display: flex; align-items: center; gap: 12px;
                    @include mobile {
                        flex-direction: row;
                        gap: 10px;
                        align-items: flex-start;
                        justify-content: flex-start;
                        align-self: flex-start;
                        .name{
                            font-weight: 700;
                        }
                        .mobile-none{
                            display: none;
                        }
                    }
                    .icon_con { border: var(--dark_blue) 1px solid; padding: 13px; width: 48px; height: 48px; border-radius: 50%;
                        .icon { width: 100%; height: 100%;}
                        @include mobile {
                            width: 36px;
                            height: 36px;
                            padding: 8px;
                            align-self: center;
                        }
                    }
                    div.text { display: flex; flex-direction: column;
                       
                        p, span { color: var(--dark_blue);}
                        p { font-size: var(--h3);
                            @include mobile {
                                font-size: 16px;
                            }
                        }
                        span { font-size: var(--h5);
                            @include mobile {
                                font-size: 15px;
                                
                            }
                        }
                    }
                }
            }
            .compare_btn_con {
                @include mobile {
                    flex-direction: row;
                    gap: 8px;

                    
                }
                p { color: var(--dark_blue);  font-size: var(--h3);
                    @include mobile {
                        font-size: 15px;
                    }
                }
            }
            .csv { cursor: pointer; display: flex; align-items: center; gap: var(--gap_sm);
                @include mobile {
                    gap: 8px;
                    padding-left:0 !important;
                    .icon {
                        width: 32px;
                        height: 32px;
                    }
                    span {
                        font-size: 18px !important;
                    }
                }
                span { color: var(--dark_blue);  font-size: var(--h4); font-weight: bold;}
                .icon {width: 48px; height: 48px; background-image: url(../assets/csv.svg); background-repeat: no-repeat; background-size: contain; }
            }
        }
        .select_res_ent_con { border-radius: var(--radius);
            @include mobile {
                border-radius: 12px !important;
                background: transparent !important;
            }
            &>* { background: #fff; }
            nav.steps_nav { display: flex; gap: var(--gap_mid); margin-bottom: var(--gap_mid);
                @include mobile {
                    gap: 6px;
                    flex-direction: column;
                }
                div { cursor: pointer; display: flex; align-items: center; gap: var(--gap_sm); padding: var(--gap_sm) var(--gap_mid); border-radius: var(--radius); border: 1px solid var(--gray); opacity: 0.7;
                    @include mobile {
                        gap: 4px;
                        padding: 6px 10px;
                        font-size: 16px;
                    }
                    &.active { opacity: 1; background: var(--pageBG); border-color: var(--dark_blue);
                        .step_number { background: var(--dark_blue); color: white; }
                    }
                    .step_number { width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; border-radius: 50%; background: var(--gray); color: var(--dark_blue);
                        @include mobile {
                            width: 18px;
                            height: 18px;
                            font-size: 12px;
                        }
                    }
                    .step_text { color: var(--dark_blue); font-weight: bold; }
                }
            }
        }
    }
    .sticky_bottom_bar { position: fixed; bottom: 0; left: 0; right: 0; background: white; box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); padding: 16px 0; z-index: 100;
        @include mobile {
            padding: 8px 0;
            display: flex;  

        }
        .centered { padding: 0 var(--gap_mid); display: flex; justify-content: space-between; align-items: center;
            @include mobile {
                flex-direction: column;
                align-items: flex-start;
                gap: 5px;
                padding: 0 8px;
            }
            .selected-count {
                span { color: var(--dark_blue); font-size: var(--h4); font-weight: bold;
                    @include mobile {
                        font-size: 16px;
                    }
                }
            }
            .stats {
                .notes-stats { display: flex; gap: var(--gap_mid);
                    @include mobile {
                        gap: 6px;
                    }
                    .note-stat { display: flex; align-items: center; gap: 8px;
                        @include mobile {
                            gap: 4px;
                        }
                        .label { color: var(--dark_blue); font-weight: bold; font-size: var(--h5);
                            @include mobile {
                                font-size: 16px;
                            }
                        }
                        .count { background: var(--btn_color); color: white; font-weight: bold; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-size: var(--h6);
                            @include mobile {
                                width: 18px;
                                height: 18px;
                                font-size: 11px;
                            }
                        }
                        .text { color: var(--dark_blue); font-size: var(--h5);
                            @include mobile {
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
            .actions { display: flex; gap: var(--gap_sm); align-items: center;
                @include mobile {
                    flex-direction: row;
                    gap: 8px;
                    width: 100%;
                    display: flex;
                    justify-content:space-around;
                    
                }
                .btn_b {
                    &:disabled { opacity: 0.5; cursor: not-allowed; }
                    &.outline { background: transparent; border: 1px solid var(--btn_color); color: var(--btn_color);
                        &:hover { background: var(--btn_color); color: white; }
                    }
                    @include mobile {
                        flex: 1;
                        font-size: 15px;
                        padding:5px auto;
                        min-width:fit-content;
                        max-width: 100%;
                    }

                }
                .btn_b.next {
                    @include mobile {
                        flex: 2;
                        text-align: center;
                        max-width: 80%;
                    }
                }
            }
        }
    }
}
@media(max-width: 768px) {
   :deep(.breadcrumbs__item){ 
     font-size: 16px; 
    }


}
</style>